
    var riot = require('riot')
    import { RefinementList } from './gb-refinement-list';
riot.tag2('gb-refinement-list', '<yield> <div id="{$navigation.name}"> <h4 class="gb-navigation-title">{$navigation.displayName}</h4> <ul> <li data-is="gb-refinement" if="{!refinement.selected || $navigable.showSelected}" each="{refinement in $navigation.refinements}" class="{gb-selected: refinement.selected}"></li> </ul> <gb-more-refinements if="{$navigation.moreRefinements}"></gb-more-refinements> </div> </yield>', 'gb-refinement-list.gb-stylish .gb-navigation-title,[data-is="gb-refinement-list"].gb-stylish .gb-navigation-title{ font-size: 18px; margin: 10px 0; } gb-refinement-list.gb-stylish ul,[data-is="gb-refinement-list"].gb-stylish ul{ margin: 0; padding-left: 8px; list-style: none; }', '', function(opts) {
    this._mixin(RefinementList);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/navigation/gb-refinement-list.tag.html